var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarterPackage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient10);\n      }\n\n      .st2 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st3 {\n        fill: url(#linear-gradient8);\n      }\n\n      .st4 {\n        fill: url(#linear-gradient11);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient16);\n      }\n\n      .st6 {\n        isolation: isolate;\n      }\n\n      .st7 {\n        fill: url(#linear-gradient12);\n      }\n\n      .st8 {\n        fill: url(#linear-gradient4);\n      }\n\n      .st9 {\n        fill: url(#linear-gradient14);\n      }\n\n      .st10 {\n        fill: url(#linear-gradient5);\n      }\n\n      .st11 {\n        fill: url(#linear-gradient3);\n      }\n\n      .st12 {\n        fill: url(#linear-gradient15);\n      }\n\n      .st13 {\n        fill: url(#linear-gradient17);\n      }\n\n      .st14 {\n        fill: url(#linear-gradient7);\n      }\n\n      .st14, .st15 {\n        mix-blend-mode: screen;\n      }\n\n      .st16 {\n        fill: url(#linear-gradient6);\n      }\n\n      .st17 {\n        fill: url(#linear-gradient13);\n      }\n\n      .st18 {\n        fill: url(#linear-gradient);\n      }\n\n      .st15 {\n        fill: url(#linear-gradient9);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 9.01,
    y1: 75.98,
    x2: 63.98,
    y2: 30.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a6c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 12.8,
    y1: 41.87,
    x2: 87.2,
    y2: 41.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#d6e2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a6c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 50,
    y1: 99.25,
    x2: 50,
    y2: 41.87,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient3",
    x1: 50,
    y1: 73.2,
    x2: 50,
    y2: 99.19,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient4",
    x1: 23.9,
    y1: 17.29,
    x2: 23.9,
    y2: 70.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d6e2f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93a6c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient5",
    x1: 76.1,
    x2: 76.1,
    xlinkHref: "#linear-gradient4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient6",
    x1: 50,
    y1: 7.17,
    x2: 50,
    y2: 76.57,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient7",
    x1: 50,
    y1: 11.84,
    x2: 50,
    y2: 71.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient8",
    x1: 50,
    y1: 58.28,
    x2: 50,
    y2: 25.46,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient9",
    x1: 37.7,
    y1: 41.87,
    x2: 62.3,
    y2: 41.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient10",
    x1: 44.36,
    y1: 28.83,
    x2: 44.36,
    y2: 41.87,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient11",
    x1: 55.64,
    y1: 41.87,
    x2: 55.64,
    y2: 28.83,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient12",
    x1: 50,
    y1: 41.87,
    x2: 50,
    y2: 41.87,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient13",
    x1: 55.64,
    y1: 48.39,
    x2: 55.64,
    y2: 35.35,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient14",
    x1: 55.64,
    y1: 54.9,
    x2: 55.64,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient15",
    x1: 44.36,
    y1: 41.87,
    x2: 44.36,
    y2: 54.9,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient16",
    x1: 44.36,
    y1: 48.39,
    x2: 44.36,
    y2: 35.35,
    xlinkHref: "#linear-gradient1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient17",
    x1: 50,
    y1: 33.29,
    x2: 50,
    y2: 50.45,
    xlinkHref: "#linear-gradient1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M50,82.99c-2.8,0-5.59-.72-8.08-2.16l-21.61-12.48c-4.99-2.88-8.08-8.25-8.08-14v-24.96c0-5.76,3.1-11.12,8.08-14L41.92,2.91C46.9.03,53.1.03,58.08,2.91l21.61,12.48c4.99,2.88,8.08,8.25,8.08,14v24.96c0,5.76-3.1,11.12-8.08,14l-21.61,12.48c-2.49,1.44-5.29,2.16-8.08,2.16ZM50,1.92c-2.59,0-5.19.67-7.5,2l-21.61,12.48c-4.63,2.67-7.5,7.65-7.5,12.99v24.96c0,5.34,2.87,10.32,7.5,12.99l21.61,12.48c4.63,2.67,10.37,2.67,15,0l21.61-12.48c4.63-2.67,7.5-7.65,7.5-12.99v-24.96c0-5.34-2.87-10.32-7.5-12.99L57.5,3.92c-2.31-1.34-4.91-2-7.5-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M87.2,54.35v-24.96c0-5.57-2.97-10.71-7.79-13.5L57.79,3.41c-4.82-2.78-10.76-2.78-15.59,0l-21.61,12.48c-4.82,2.78-7.79,7.93-7.79,13.5v24.96c0,5.57,2.97,10.71,7.79,13.5l21.61,12.48c4.82,2.78,10.76,2.78,15.59,0l21.61-12.48c4.82-2.78,7.79-7.93,7.79-13.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "34.36 41.87 34.36 90.23 50 99.25 65.64 90.23 65.64 41.87 34.36 41.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "36.7 88.88 36.7 44.21 63.3 44.21 63.3 88.88 50 96.55 36.7 88.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M6.4,48.13l39.13,22.59v-28.46L2.27,17.29v23.69c0,2.95,1.57,5.68,4.13,7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M54.47,42.26v28.46l39.13-22.59c2.56-1.48,4.13-4.2,4.13-7.15v-23.69l-43.26,24.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M50,76.57c-1.71,0-3.39-.45-4.87-1.31l-21.61-12.48c-3-1.73-4.87-4.97-4.87-8.44v-24.96c0-3.47,1.87-6.7,4.87-8.44l21.61-12.48c1.48-.85,3.16-1.3,4.87-1.3s3.39.45,4.87,1.3l21.61,12.48c3,1.73,4.87,4.97,4.87,8.44v24.96c0,3.47-1.87,6.7-4.87,8.44l-21.61,12.48c-1.48.85-3.16,1.31-4.87,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M50,71.89c-.89,0-1.76-.23-2.53-.68l-21.61-12.48c-1.56-.9-2.53-2.58-2.53-4.39v-24.96c0-1.8.97-3.48,2.53-4.39l21.61-12.48c.77-.44,1.64-.68,2.53-.68s1.76.23,2.53.68l21.62,12.48c1.56.9,2.53,2.58,2.53,4.39v24.96c0,1.8-.97,3.49-2.53,4.39l-21.61,12.48c-.77.44-1.64.68-2.53.68Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "35.79 50.07 35.79 33.66 50 25.46 64.21 33.66 64.21 50.07 50 58.28 35.79 50.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "37.7 48.97 37.7 34.77 50 27.66 62.3 34.77 62.3 48.97 50 56.07 37.7 48.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "50 28.83 50 28.83 38.71 35.35 50 41.87 50 28.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "50 41.87 61.29 35.35 61.29 35.35 50 28.83 50 41.87 50 41.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "50 41.87 50 41.87 50 41.87 50 41.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "50 41.87 61.29 48.39 61.29 35.35 50 41.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "50 41.87 50 54.9 50 54.9 61.29 48.39 61.29 48.39 50 41.87 50 41.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st12",
    points: "38.71 48.39 38.71 48.39 50 54.9 50 41.87 38.71 48.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "50 41.87 38.71 35.35 38.71 35.35 38.71 48.39 50 41.87 50 41.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "50 33.29 50 33.29 42.57 37.58 42.57 37.58 42.57 46.16 42.57 46.16 50 50.45 50 50.45 57.43 46.16 57.43 46.16 57.43 37.58 57.43 37.58 50 33.29"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarterPackage);
export default __webpack_public_path__ + "static/media/STARTER-PACKAGE.7ec89b9cf3e91639161990c9802cc1c9.svg";
export { ForwardRef as ReactComponent };